import { IFetchUnitByIdDTO } from 'shared/domain/dtos';
import { IUnitsRepository } from 'shared/domain/repositories';

export default class FetchUnitByIdUseCase {
  constructor(private unitsRepository: IUnitsRepository) {}

  public async execute(dto: IFetchUnitByIdDTO) {
    return this.unitsRepository.findById({ id: dto.id });
  }
}
